import { CommonRouter, i18n, Image, utils } from '@common';
import { routerPaths } from './tool';
import { accountService } from '@api';
import Home from './home';
import StudentManagement from './studentManagement';
import GroupManagement from './groupManagement';
import GroupDetails from './groupManagement/details';
import ReportingRouter from './reporting/router';
import EmailTemplate from './emailTemplate';
import { withRouter } from 'react-router-dom';
import Layout from './layout';
import { permissionEmailTemplate, permissionReport, permissionStudentManagement, permissionStaffAccessReview, permissionGroupManagement } from './constant';
import { FAQAdmin } from '../../Common/components/footer';

const WithRouterLayout = withRouter(Layout);
const routers = [
    {
        path: routerPaths.home,
        component: Home,
        exact: true,
        breadcrumbs: [{ text: i18n.get('CIS_Nav_Dashboard_Entry'), icon: 'fia-compass' }],
    },
    {
        path: routerPaths.studentManagement,
        component: StudentManagement,
        exact: true,
        breadcrumbs: [{ text: i18n.get('CIS_Nav_Student_Management_Entry'), icon: 'fia-student' }],
        role: () => permissionStudentManagement?.read
    },
    {
        path: routerPaths.groupManagement,
        component: GroupManagement,
        exact: true,
        breadcrumbs: [{ text: i18n.get('CIS_Nav_Group_Management_Entry'), icon: 'fia-users' }],
        role: () => permissionGroupManagement?.read
    },
    {
        path: routerPaths.groupDetails,
        component: GroupDetails,
        exact: true,
        breadcrumbs: [
            { text: i18n.get('CIS_Nav_Group_Management_Entry'), icon: 'fia-users', url: routerPaths.groupManagement },
            { text: i18n.get('CIS_Admin_GroupManagement_Details_Entry') }
        ],
        role: () => permissionGroupManagement?.read
    },
    {
        path: routerPaths.reporting,
        component: ReportingRouter,
        breadcrumbs: [{ text: i18n.get('CIS_Nav_Reporting_Entry'), icon: 'fia-file' }],
        role: () => permissionReport?.read
    },
    {
        path: routerPaths.emailTemplate,
        component: EmailTemplate,
        exact: true,
        breadcrumbs: [{ text: i18n.get('CIS_Nav_Email_Template_Entry'), icon: 'fia-email-envelope' }],
        role: () => permissionEmailTemplate?.read
    },
    {
        path: routerPaths.FAQ,
        component: FAQAdmin,
        exact: true,
    },
];

const navigations = [
    {
        id: 'leftnav-dashboard',
        text: i18n.get('CIS_Nav_Dashboard_Entry'),
        icon: 'fia-compass',
        color: '#415364',
        activeColor: '#0866CA',
        url: routerPaths.home,
        isActive: (match, location) => {
            return location.pathname == routerPaths.home;
        }
    },
    {
        id: 'leftnav-student-managment',
        text: i18n.get('CIS_Nav_Student_Management_Entry'),
        icon: 'fia-student',
        color: '#415364',
        activeColor: '#0866CA',
        url: routerPaths.studentManagement,
        role: () => permissionStudentManagement?.read
    },
    {
        id: 'leftnav-group-managment',
        text: i18n.get('CIS_Nav_Group_Management_Entry'),
        icon: 'fia-users',
        color: '#415364',
        activeColor: '#0866CA',
        url: routerPaths.groupManagement,
        role: () => permissionGroupManagement?.read
    },
    {
        id: 'leftnav-reporting',
        text: i18n.get('CIS_Nav_Reporting_Entry'),
        icon: 'fia-file',
        color: '#415364',
        activeColor: '#0866CA',
        url: routerPaths.reporting,
        role: () => permissionReport?.read
    },
    {
        id: 'leftnav-email-template',
        text: i18n.get('CIS_Nav_Email_Template_Entry'),
        icon: 'fia-email-envelope',
        color: '#415364',
        activeColor: '#0866CA',
        url: routerPaths.emailTemplate,
        role: () => permissionEmailTemplate?.read
    },
];

export default class Router extends R.Component {
    componentCreate() {
        this.bind('onChange');
    }
    onChange = (router) => {
        if (router && (router?.path === routerPaths.home || router?.path === routerPaths.reporting)) {
            accountService.getCurrentUser().catch(e => {
                utils.redirectTo(`${utils.getOriginUrl()}/error/urlexpired`);
            });
        }

        if (router && router.breadcrumbs) {
            let breadcrumbs = [...router.breadcrumbs];
            this.setBreadcrumbs(breadcrumbs);
        }
        
        const toast = document.getElementsByClassName('aui-toast');
        if (toast?.length >= 1) {
            toast[0].innerHTML = '';
        }
    };
    render() {
        return (
            <WithRouterLayout
                navigations={navigations}
                logo={{
                    icon: Image.admin.logo,
                    to: "/admin"
                }}
            >
                <CommonRouter routers={routers} onChange={this.onChange} />
            </WithRouterLayout>
        );
    }
}